/* eslint-disable no-console */
import { trackSpotlightPromotionEvent } from "@DSG/Common/DSGTracking";
import { addToChainAfter, addToEndOfChain, Handler } from "@insite/client-framework/HandlerCreator";
import { Category } from "@insite/client-framework/Services/CategoryService";
import {
    GetAlsoPurchasedProductCollectionApiV2Parameter,
    GetProductCollectionApiV2Parameter,
    getProductCollectionV2,
    GetRelatedProductCollectionApiV2Parameter,
} from "@insite/client-framework/Services/ProductServiceV2";
import {
    chain,
    LoadProducts,
    LoadRecommendedProducts,
} from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import { BrandModel, ProductModel } from "@insite/client-framework/Types/ApiModels";

export interface DSGProductCarouselParameter {
    carouselId: string;
    carouselType: string;
    relatedProductType: string;
    seedWithManuallyAssigned: string;
    displayProductsFrom: string;
    selectedCategoryIds: string[];
    numberOfProductsToDisplay: number;
    isProductDetailsPage: boolean;
    productId?: string;
    isProductListPage: boolean;
    category?: Category;
    isBrandDetailsPage: boolean;
    brand?: BrandModel;
    isShellEdit?: boolean;
    widgetPosition?: number;
    productNumbers?: string[];
}
interface Props {
    getProductCollectionParameter?:
        | GetProductCollectionApiV2Parameter
        | GetRelatedProductCollectionApiV2Parameter
        | GetAlsoPurchasedProductCollectionApiV2Parameter;
    extraProductCollectionParameter?:
        | GetProductCollectionApiV2Parameter
        | GetRelatedProductCollectionApiV2Parameter
        | GetAlsoPurchasedProductCollectionApiV2Parameter;
    additionalSort?: (products: ProductModel[]) => ProductModel[];
}

type HandlerType = Handler<DSGProductCarouselParameter, Props>;
export const LoadProductSpotlight: HandlerType = props => {
    if (!props.parameter.productNumbers || props.parameter.productNumbers.length === 0) {
        return;
    }
    props.getProductCollectionParameter = { productNumbers: props.parameter.productNumbers };
};

addToChainAfter(chain, LoadRecommendedProducts, LoadProductSpotlight);

type TrackingParameters = Parameters<typeof LoadProducts>[0];
addToEndOfChain(chain, trackCarouselProducts);
async function trackCarouselProducts(props: TrackingParameters) {
    try {
        const spotLightParams = props.parameter.carouselType;
        const [carosalType, title, currentTabLable, currnttab] = spotLightParams.split("|");
        if (carosalType === "SpotlightPromotion") {
            const parameter = {
                productNumbers: "productNumbers" in props.parameter ? props.parameter?.productNumbers : [],
            } as GetProductCollectionApiV2Parameter;

            const response = await getProductCollectionV2(parameter);

            const products = response?.products;

            if (products) {
                trackSpotlightPromotionEvent(
                    props.parameter.carouselId,
                    title || "",
                    currentTabLable,
                    currnttab ?? "",
                    products,
                );
            }
        }
    } catch (error) {
        console.log("error ->", error);
    }
}
